import { render, staticRenderFns } from "./supportField.vue?vue&type=template&id=85df64e0&scoped=true&"
import script from "./supportField.vue?vue&type=script&lang=js&"
export * from "./supportField.vue?vue&type=script&lang=js&"
import style0 from "./supportField.vue?vue&type=style&index=0&id=85df64e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85df64e0",
  null
  
)

export default component.exports